import React from "react";
import Details from "../containers/Details";
import Attendance from "../containers/Attendance";
import { ReactComponent as ArrowBack } from "../build/images/platformnps/arrowback.svg"
import { useDispatch, useSelector } from "react-redux";
import atdsimult from "../reducers/atdsimult";
import { ShowInfoDisplay } from "../actions";

let isAnswer = false;

const PlatformNps = ({}) => {
  const atdReducer = useSelector(state => state.atdsimult);
  const dispatch = useDispatch();

  if(atdReducer.length !== 0){
    isAnswer = true;
  }

  if(atdReducer.length === 0 && isAnswer === true){
    isAnswer = false;
    dispatch(ShowInfoDisplay("NPS"))
  }

  return (
    <div className="platform-nps__container">
        <div className="platform-nps__container-header">
            <ArrowBack />
            <span>Tratar resposta</span>
        </div>
        <div className="platform-nps__container-content">
            <Attendance />
            <Details displayscreen="platform-nps" />
        </div>
    </div>
  );
};

export default PlatformNps;
